module.exports = __webpack_public_path__ + "public/SiteIcons/exportItemIcon.svg?f42c32e9";